"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
import { CircleQuestionMark, ArrowRight } from "lucide-react";
const faqData = [{
  question: "Jaký je minimální objem prádla pro navázání spolupráce?",
  answer: "Jako průmyslová prádelna se specializujeme na velkokapacitní zakázky pro hotely, restaurace, AirBnB a wellness. Obvykle spolupracujeme s klienty, jejichž měsíční objem prádla přesahuje 500 kg. Pro menší provozy však umíme připravit individuální nabídku v závislosti na logistické dostupnosti."
}, {
  question: "Jak pečujete o jemné textilie pro wellness a spa?",
  answer: "Chápeme, že wellness textilie vyžadují specifickou péči pro zachování měkkosti a savosti. Používáme specializované prací programy s šetrnou chemií, která nenarušuje vlákna, a zároveň garantujeme nejvyšší hygienické standardy dezinfekce, které jsou pro spa provozy klíčové."
}, {
  question: "Je možné smluvně zajistit noční doručování a svoz?",
  answer: "Ano, noční logistika je jednou z našich hlavních konkurenčních výhod. Nabízíme možnost svozu a závozu v nočních hodinách (22:00 – 06:00), abychom nenarušovali denní provoz vašeho hotelu či restaurace."
}, {
  question: "Jak rychle dokážete reagovat na mimořádné výkyvy v objemu?",
  answer: "Díky naší vysoké kapacitě a flexibilnímu směnnému provozu jsme schopni pokrýt i sezónní špičky nebo nečekané nárůsty objemu (např. při plné obsazenosti hotelu během konferencí)."
}];
export default function B2BClientFaq() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="časté-dotazy-b2b-klientů" className="bg-background py-24 relative overflow-hidden">
      {}
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-border to-transparent opacity-50" />
      
      <div className="container mx-auto px-4 md:px-6 max-w-5xl">
        <div ref={ref} className={cn("transition-all duration-700 ease-out transform", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8")}>
          <div className="text-center mb-16 space-y-4">
            <div className="inline-flex items-center justify-center p-2 bg-muted/50 rounded-full mb-4">
              <CircleQuestionMark className="w-5 h-5 text-primary mr-2" />
              <span className="text-sm font-medium text-muted-foreground uppercase tracking-wider">
                B2B Podpora
              </span>
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-foreground tracking-tight">
              Časté dotazy B2B klientů
            </h2>
            <p className="text-muted-foreground max-w-2xl mx-auto text-lg">
              Odpovědi na klíčové otázky týkající se průmyslového praní, logistiky a smluvních podmínek pro hotely a restaurace.
            </p>
          </div>

          <div className="bg-card border border-border rounded-xl shadow-sm p-6 md:p-10">
            <Accordion type="single" collapsible className="w-full">
              {faqData.map((item, i) => <AccordionItem key={i} value={`item-${i}`} className="border-b-border last:border-0 px-2" data-index={i}>
                  <AccordionTrigger className="text-left text-base md:text-lg font-medium text-foreground hover:text-primary hover:no-underline py-5 transition-colors">
                    {item.question}
                  </AccordionTrigger>
                  <AccordionContent className="text-muted-foreground text-base leading-relaxed pb-6 pr-4 md:pr-12">
                    {item.answer}
                  </AccordionContent>
                </AccordionItem>)}
            </Accordion>
          </div>

          <div className="mt-12 text-center bg-muted/30 rounded-lg p-8 border border-border/50">
            <h3 className="text-xl font-semibold text-foreground mb-3">
              Nenašli jste odpověď?
            </h3>
            <p className="text-muted-foreground mb-6 max-w-xl mx-auto">
              Náš tým je připraven zodpovědět jakékoli specifické dotazy ohledně kapacity, cenové nabídky nebo technických požadavků.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button asChild size="lg" className="font-medium">
                <Link to="/ContactPage">
                  Kontaktovat obchodní oddělení
                  <ArrowRight className="ml-2 w-4 h-4" />
                </Link>
              </Button>
              <Button asChild variant="outline" size="lg" className="bg-background hover:bg-accent">
                <Link to="tel:+420607774723">Zavolat na +420 607 774 723</Link>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}